import { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { postMethod } from "../../../function/helper";
import FooterPostup from "../../../modules/public/footer/footer";
import Menu from "../../../modules/public/menu/menu";
import AuthModal from "./components/AuthModal";
import "./login.css";

export default function Login() {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingSecond, setLoadingSecond] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [show, setShow] = useState(false);

  const [forgetPasswordForm, setForgetPasswordForm] = useState({
    phone: undefined,
    nationalCode: undefined,
  });

  const [showAuthModal, setShowAuthModal] = useState(false);

  const setField = (field, value) => {
    setForm({ ...form, [field]: value });
    if (errors[field]) setErrors({ ...errors, [field]: null });
  };

  const findFormErrors = () => {
    const { nationalCode, password } = form;

    const newErrors = {};

    if (!nationalCode || nationalCode === "") {
      newErrors.nationalCode = "کد ملی الزامی است";
    }

    if (!password || password === "") {
      newErrors.password = "رمز الزامی است";
    }

    return newErrors;
  };

  const sendData = async () => {
    setLoading(true);
    const response = await postMethod("/user/v1/login", form);

    if (response.status === 200) {
      localStorage.setItem("token", response.data.data);
      window.location.href = "/";
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        customClass: "rtl-all",
        text: response.data.data,
        showConfirmButton: response.data?.code === 1,
        showCancelButton: true,
        cancelButtonColor: "gray",
        cancelButtonText: "متوجه شدم",
        confirmButtonText: "ارسال پیامک احراز هویت",
      }).then(res => {
        if (res.isConfirmed) {
          setShowAuthModal(true);
        }
      });
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      sendData();
    }
  };

  const sendPass = async e => {
    e.preventDefault();

    setLoadingSecond(true);

    const response = await postMethod(
      "/user/v1/forgetpassword",
      forgetPasswordForm
    );
    setLoadingSecond(false);

    if (response && response.status === 200) {
      setShow(false);
      Swal.fire({
        icon: "success",
        text: response.data.data,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
      });
    } else {
      Swal.fire({
        icon: "error",
        text: response?.data.data ?? "عملیات با خطا مواجه شد",
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
      });
    }
  };

  useMemo(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "instant" });
  };

  useEffect(() => {
    scrollToBottom();
  }, []);

  return (
    <>
      <div ref={messagesEndRef} />
      <Menu />

      <Container className="loginContainer flex-grow-1">
        <Row
          xl={2}
          lg={2}
          md={2}
          xs={1}
          className="justify-content-center align-items-center"
        >
          <Col className="d-none d-md-block">
            <img
              className="w-100"
              src="/auth/sing.png"
              style={{ aspectRatio: "1 / 1" }}
            />
          </Col>

          <Col className="loginCard mt-5 mt-md-0">
            <div className="loginFormCol">
              <Card className="loginForm">
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                    <Form.Label>شماره موبایل یا کد ملی</Form.Label>
                    <Form.Control
                      value={form.nationalCode}
                      type="text"
                      onChange={e => setField("nationalCode", e.target.value)}
                      isInvalid={!!errors.nationalCode}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.nationalCode}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group style={{ position: "relative" }}>
                    <Form.Label>رمز</Form.Label>
                    <Form.Control
                      value={form.password}
                      type={isVisible ? "text" : "password"}
                      onChange={e => setField("password", e.target.value)}
                      isInvalid={!!errors.password}
                    />
                    <span
                      type="icon"
                      onClick={() => setIsVisible(!isVisible)}
                      style={{
                        position: "absolute",
                        left: "7px",
                        top: "33px",
                      }}
                    >
                      {isVisible ? <EyeFill /> : <EyeSlashFill />}
                    </span>
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <p className="mt-2 mb-4">
                    <span>اگر هنوز ثبت نام نکرده‌اید </span>
                    <Link to="/register" className="text-decoration-underline">
                      از اینجا ثبت نام کنید.
                    </Link>
                  </p>

                  <div className="d-flex">
                    <div className="loginButtonDiv">
                      {loading === true ? (
                        <Button className="loginButton2" type="button">
                          <div className="d-flex align-items-center">
                            <Spinner
                              style={{
                                width: "20px",
                                height: "20px",
                                fontSize: "0.8rem",
                              }}
                            />
                            <span className="me-1"> در حال ورود</span>
                          </div>
                        </Button>
                      ) : (
                        <Button type="submit" className="loginButton2">
                          <span>ورود</span>
                        </Button>
                      )}

                      <Button
                        type="button"
                        className="forgetButton"
                        onClick={() => {
                          setShow(true);
                        }}
                      >
                        فراموشی رمز عبور
                      </Button>
                    </div>
                  </div>
                </Form>

                <Modal show={show} dir="rtl">
                  <Modal.Header className="d-flex align-item-center justify-content-center">
                    <Modal.Title className="h5" style={{ textAlign: "right" }}>
                      موارد زیر را وارد کنید تا رمز جدید از طریق پیامک برای شما
                      ارسال گردد
                    </Modal.Title>
                  </Modal.Header>
                  <Form>
                    <Modal.Body
                      style={{ direction: "rtl" }}
                      className="dir d-flex flex-column"
                    >
                      <Form.Group className="w-100">
                        <Form.Label>کد ملی:</Form.Label>
                        <Form.Control
                          type="number"
                          value={forgetPasswordForm.nationalCode}
                          onChange={e =>
                            setForgetPasswordForm(cur => ({
                              ...cur,
                              nationalCode: e.target.value,
                            }))
                          }
                        />
                      </Form.Group>
                      <Form.Group className="w-100">
                        <Form.Label>شماره موبایل:</Form.Label>
                        <Form.Control
                          value={forgetPasswordForm.phone}
                          type="number"
                          onChange={e =>
                            setForgetPasswordForm(cur => ({
                              ...cur,
                              phone: e.target.value,
                            }))
                          }
                        />
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer
                      className="d-flex flex-row align-item-center justify-content-center"
                      dir="rtl"
                    >
                      {loadingSecond === true ? (
                        <Button className="btn-success-style">
                          <div className="d-flex align-items-center">
                            <Spinner
                              style={{
                                width: "20px",
                                height: "20px",
                                fontSize: "0.8rem",
                              }}
                            />
                            <span className="me-1"> در حال ارسال</span>
                          </div>
                        </Button>
                      ) : (
                        <Button
                          className="btn-success-style"
                          onClick={sendPass}
                        >
                          <span>ارسال</span>
                        </Button>
                      )}

                      <Button
                        className="btn-cancel-style"
                        type="button"
                        onClick={() => setShow(false)}
                      >
                        بستن
                      </Button>
                    </Modal.Footer>
                  </Form>
                </Modal>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>

      {showAuthModal && (
        <AuthModal
          close={() => setShowAuthModal(false)}
          nationalCode={form.nationalCode}
        />
      )}

      <FooterPostup />
    </>
  );
}
